// Auto-discover pictures from src/assets/pictures (optional).
// Drop images in src/assets/pictures and they will show in My Pictures.

function titleCaseFromSlug(slug) {
  return slug
    .replace(/[-_]+/g, ' ')
    .replace(/\.[^.]+$/, '')
    .replace(/\b\w/g, s => s.toUpperCase());
}

let AUTO_PICTURES = [];
try {
  // Webpack-specific: CRA supports require.context
  const ctx = require.context(
    'assets/pictures',
    false,
    /\.(png|jpe?g|gif|svg)$/i,
  );
  AUTO_PICTURES = ctx.keys().map(key => {
    const src = ctx(key);
    const id = key.replace(/^\.\//, '');
    return {
      id,
      src,
      title: titleCaseFromSlug(id),
      description: '',
    };
  });
} catch (e) {
  // Folder may not exist yet; that's ok.
  AUTO_PICTURES = [];
}

export { AUTO_PICTURES };
